<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet class="contents-container">
      <v-sheet class="w-full">
        <i-card-vertical headerTitle="안전보건경영 관리" device="multi" contentsClass="overflow-x-hidden overflow-y-auto pr-5" :IsUseInfo="true">
          <template v-slot:Info>
            <span v-if="esgHrNoCheck === 'Y'">근로자 확인 여부 : 확인</span>
            <span v-else>근로자 확인 여부 : 미확인</span>
          </template>
          <template v-slot:body>
            <v-tabs active-class="active_tab" class="mt-3" v-model="tab">
              <v-tab class="px-2" v-for="item in tabs" :key="item.tabpageId" @click="clickTab(item.tabpageId)">{{ item.title }}</v-tab>
              <v-tabs-items v-model="tab" :touchless="true">
                <!-- ######################## 기존 ############################ -->
                <v-tab-item>
                  <NewPolicy ref="newPolicy" :datasource="newShData" :guide-highlight="guideHighlightFile" />
                </v-tab-item>
                <!-- ######################## 신규 ############################ -->
                <v-tab-item>
                  <LegacyPolicy ref="legacyPolicy" :datasource="legacyShData" />
                </v-tab-item>
              </v-tabs-items>
            </v-tabs>

            <!-- <v-col cols="12" sm="12" lg="12" class="pa-2 pt-0">
                    <i-card-top
                      class="d-md-flex"
                      headerTitle
                      :useBtnList="['btnSearch']"
                      @btnSearch="getUserComment()"
                    >
                      <template v-slot:body>
                        <v-layout>
                          <v-row no-gutters class="center pa-0 pa-md-2 pb-0">
                            <v-col cols="4" md="4">
                              <v-select
                                :menu-props="{ offsetY: true }"
                                color="primary"
                                class="mx-1"
                                item-text="sub1"
                                item-value="grpAuthCd"
                                :items="selectedGrp"
                                placeholder="그룹권한"
                                dense
                                outlined
                                clearable
                                v-model="selectedGrpCd"
                              />
                            </v-col>
                          </v-row>
                        </v-layout>
                      </template>
                    </i-card-top>
            </v-col>-->
          </template>

          <template v-slot:drawer>
            <v-navigation-drawer v-model="feedbackShow" width="75%" absolute right temporary class="feedback-area">
              <expansionPanelList
                :subTitle="'근로자 의견'"
                :datasource="userCommentList"
                :readonly="false"
                headerDefaultColor="#fff"
                headerExpandedColor="#fff"
                @save="saveCommentData"
                @update="updateCommentData"
                @delete="deleteCommentData"
              />
            </v-navigation-drawer>

            <v-navigation-drawer v-model="procedureShow" width="75%" absolute right temporary class="feedback-area">
              <ProcedureComponent :type="'00001'" />
            </v-navigation-drawer>
          </template>
        </i-card-vertical>
      </v-sheet>
      <v-sheet class="iCardRightWrap" :key="selectedTab" :class="{ 'guide-highlight-sample': guideHighlightSample }">
        <i-card-right
          v-if="selectedTab === 'new'"
          :useBtnList="buttonUseListNew"
          @btnSample="btnSample"
          @btnSearch="btnSearch()"
          @btnSave="btnSave"
          @btnPrint="btnPrint"
        ></i-card-right>
        <i-card-right
          v-else-if="selectedTab === 'legacy'"
          :useBtnList="buttonUseListLagacy"
          @btnSearch="btnSearch()"
          @btnImageDownload="btnImageDownload()"
          @btnImageLoad="btnImageLoad()"
          @btnSave="btnSave"
          @btnPrint="btnPrint"
        ></i-card-right>
        <i-card-right>
          <template v-slot:customBtn>
            <i-icon-button
              v-if="esgHrNoCheck === 'N'"
              color="btn_text"
              :text="'근로자 확인'"
              :icon="'check'"
              :appendDivider="true"
              @click="checkHrNo()"
            ></i-icon-button>
            <i-icon-button
              color="btn_text"
              :text="'근로자 의견'"
              :icon="'feedback'"
              @click="feedbackShow = !feedbackShow"
              :appendDivider="true"
            ></i-icon-button>
            <i-icon-button color="btn_text" :text="'절차서'" :icon="'file'" @click="procedureShow = !procedureShow"></i-icon-button>
          </template>
        </i-card-right>
      </v-sheet>
    </v-sheet>
  </v-container>
</template>

<script>
// 공통 컴포넌트
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import iCardTop from '@/components/common/iCardTop.vue'
import iCardVertical from '@/components/common/iCardVertical.vue'
import expansionPanelList from '@/components/esgCommon/expansionPanelList.vue'
import notify from 'devextreme/ui/notify'
import { getCurrentDate } from '@/utils/common.js'
// 사용자 컴포넌트
import LegacyPolicy from './LegacyPolicy' // '기존'탭 컴포넌트
import NewPolicy from './NewPolicy_new' // '신규'탭 컴포넌트
import { AesEncrypt, AesDecrypt } from '@/utils/aes256'
import { getUserCd } from '@/utils/token'

// API
import {
  getSHManageData,
  getSHManagePolicyComment,
  getSHManageDataReport,
  confirmSHManagePolicy,
  saveSHPolicyComment,
  updateSHPolicyComment,
  deleteSHPolicyComment,
} from '@/api/leaderShip/shManagePolicy_new'
import ProcedureComponent from '@/views/procedure/components/ProcedureComponent.vue'
import { getLeaderShipProcedure } from '@/api/procedure/leaderShipProcedure.js'

export default {
  mixins: [baseview],
  components: {
    // 'i-card-top': iCardTop,
    'i-card-vertical': iCardVertical,
    expansionPanelList,
    LegacyPolicy,
    NewPolicy,
    ProcedureComponent,
  },
  data() {
    return {
      initCompId: '',
      buttonUseListNew: [
        'btnSample', // 예시보기
        'btnSearch', // 조회
        'btnSave', // 저장
        'btnPrint', // 출력
      ],
      buttonUseListLagacy: [
        'btnSearch', // 조회
        'btnImageDownload', // 이미지 다운로드
        'btnImageLoad', // 이미지 불러오기
        'btnSave', // 저장
        'btnPrint', // 출력
      ],
      tabs: [
        { tabpageId: 'new', title: '신규' },
        { tabpageId: 'legacy', title: '기존' },
      ],
      tab: '', // 기존, 신규 탭 구분변수
      selectedTab: 'new', // 기존, 신규 탭 구분변수
      legacyShData: {}, // 기존 데이터
      newShData: {}, // 신규 데이터
      userCommentList: [],

      defaultComment: [
        {
          main: '의견 없음',
          sub1: '-',
          sub2: getCurrentDate().replaceAll('-', '.'),
          text: '근로자 의견 없음',
        },
      ],
      selectedGrp: [
        {
          sub1: '전체',
          grpAuthCd: 'all',
        },
      ],
      selectedGrpCd: 'all',
      feedbackShow: false, // 피드백 보이기
      procedureShow: false, // 절차서 보이기
      esgHrNoCheck: 'N', // 근로자 확인 여부
      guideHighlightSample: false, // 안전보건관리체계 구축 진행도 이동 시 예시 보기 버튼 깜빡임
      guideHighlightFile: false, // 안전보건관리체계 구축 진행도 이동 시 업로드파일 영역 깜빡임
      _guideHighlightTimer: null,
    }
  },
  watch: {
    // 안전보건관리체계 구축 진행도에서 같은 경로로 재이동할 때(query._t) 가이드 하이라이트 재적용
    '$route.query._t'(val, oldVal) {
      if (val && oldVal && val !== oldVal) {
        this.applyGuideHighlightFromRoute()
      }
    },
  },
  computed: {},
  created() {
    this.initCompId = this.getCompId() // 초기 페이지 진입 시 compId 세팅
  },
  beforeMount() {},
  mounted() {
    this.btnSearch(true)
    this.applyGuideHighlightFromRoute()
  },
  activated() {
    if (this.$route.params?.data?.guideHighlight) {
      this.applyGuideHighlightFromRoute()
    }
    // if (this.changedCompFlag(this.initCompId)) {
    //   // 로컬 스토리지에 저장된 값을 비교하여 변경 전 / 변경 후 compId가 다르고,
    //   // 페이지 진입시 세팅해두었던 compId 와 변경 후 compId와 다를 경우
    //   this.initCompId = this.getCompId()
    //   this.btnSearch(true)
    // }
  },
  beforeDestroy() {
    if (this._guideHighlightTimer) {
      clearTimeout(this._guideHighlightTimer)
      this._guideHighlightTimer = null
    }
  },
  methods: {
    // 안전보건관리체계 구축 진행도에서 진입 시 예시 보기·업로드파일 영역을 붉게 깜빡여 안내
    applyGuideHighlightFromRoute() {
      const routeData = this.$route.params && this.$route.params.data
      if (!routeData || !routeData.guideHighlight) return

      if (this._guideHighlightTimer) {
        clearTimeout(this._guideHighlightTimer)
        this._guideHighlightTimer = null
      }
      this.guideHighlightSample = false
      this.guideHighlightFile = false

      // 예시 보기·업로드는 신규 탭에 있으므로 신규 탭으로 이동
      this.tab = 0
      this.selectedTab = 'new'

      this.$nextTick(() => {
        this.guideHighlightSample = true
        this.guideHighlightFile = true
        this._guideHighlightTimer = setTimeout(() => {
          this.guideHighlightSample = false
          this.guideHighlightFile = false
          this._guideHighlightTimer = null
        }, 5000)
      })
    },
    btnSample() {
      this.$refs.newPolicy.btnSampleLoad() // newPoily 신규 탭 예시보기
    },
    btnImageDownload() {
      this.$refs.legacyPolicy.btnImageDownload() // legacyPolicy 기존 탭 이미지 다운로드
    },
    btnImageLoad() {
      this.$refs.legacyPolicy.btnImageLoad() // legacyPolicy 기존 탭 이미지 불러오기
    },
    async btnSearch(init = false) {
      // 조회
      let param = {
        clntId: this.getClntId(),
      }
      this.openLoading()
      if (this.selectedTab == 'legacy' || init) {
        await getSHManageData({ ...param, ...{ dataType: '00001' } }, true).then((res) => {
          this.legacyShData = res.clntId ? res : {}
          this.esgHrNoCheck = res.esgHrNoCheck
        })
      }
      if (this.selectedTab == 'new' || init) {
        await getSHManageData({ ...param, ...{ dataType: '00002' } }, true)
          .then((res) => {
            this.newShData = res.clntId ? res : {}
            this.esgHrNoCheck = res.esgHrNoCheck
          })
          .finally(() => {
            this.$refs.newPolicy.searchFile()
          })
      }
      this.getUserComment()

      this.endLoading()
    },
    checkHrNo() {
      const params = {
        clntId: this.getClntId(),
        compId: this.getCompId(),
        dataType: this.selectedTab === 'new' ? '00002' : '00001',
      }
      this.openLoading()
      confirmSHManagePolicy(params)
        .then((response) => {
          this.btnSearch()
        })
        .catch((error) => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    // 근로자 의견 추가
    saveCommentData(data) {
      const param = {
        clntId: this.getClntId(),
        dataType: this.selectedTab === 'new' ? '00002' : '00001',
        workerComment: data,
      }
      this.openLoading()
      saveSHPolicyComment(param, true)
        .then((res) => {
          this.getUserComment()
          this.endLoading()
        })
        .catch((error) => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    // 근로자 의견 수정
    updateCommentData(data) {
      console.log('data', data)
      this.openLoading()
      const param = {
        clntId: data.clntId,
        dataType: data.dataType,
        writeDt: data.writeDt,
        docNo: data.docNo,
        esgHrNo: data.esgHrNo,
        workerComment: data.text,
      }
      updateSHPolicyComment(param, true)
        .then((res) => {
          this.getUserComment()
          this.endLoading()
        })
        .catch((error) => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    // 근로자 의견 삭제
    deleteCommentData(data) {
      const param = {
        clntId: data.clntId,
        dataType: data.dataType,
        writeDt: data.writeDt,
        docNo: data.docNo,
        esgHrNo: data.esgHrNo,
      }
      this.openLoading()
      deleteSHPolicyComment(param, true)
        .then((res) => {
          this.getUserComment()
          this.endLoading()
        })
        .catch((error) => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnSave() {
      // this.$refs.newPolicy.btnSave().then(res => {})
      if (this.selectedTab === 'new') await this.$refs.newPolicy.btnSave() // newPoily 신규 탭 저장
      if (this.selectedTab === 'legacy') await this.$refs.legacyPolicy.btnSave() // legacyPolicy 기존 탭 저장
    },
    btnPrint(type) {
      // 출력
      if (Object.keys(this.newShData).length > 0 || !this.$refs.newPolicy.params.__created__) {
        // 신규 데이터가 있을 경우
        this.openLoading()
        let params = {
          clntId: this.getClntId(),
          type: type,
        }
        getSHManageDataReport(params, false)
          .then((res) => {
            this.downloadReport(res)
          })
          .catch(() => {
            this.endLoading()
          })
          .finally(() => {
            this.endLoading()
          })
        return
      } else if (Object.keys(this.legacyShData).length > 0 || !this.$refs.legacyPolicy.params.__created__) {
        // 신규데이터가 없고 기존 데이터만 있을 경우
        this.vSnackbar(this.$t('신규 데이터가 없습니다. 기존 이미지 다운로드 버튼을 클릭해주세요.'), 'warn')
        return
      }
      this.vSnackbar(this.$t('출력할 데이터가 없습니다.'), 'warn')
    },

    getUserComment() {
      this.selectedGrp = [
        {
          sub1: '전체',
          grpAuthCd: 'all',
        },
      ]
      let params = {
        clntId: this.getClntId(),
        grpAuthCd: this.selectedGrpCd,
        // writeDt: ''
      }
      getSHManagePolicyComment(params, true).then((res) => {
        if (res.success) {
          if (res.list.length == 0) {
            this.userCommentList = this.defaultComment
            return
          }
          res.list.forEach((el) => {
            el.sub1 = el.grpAuthNm
            el.sub2 = el.updatedBy ? el.updatedAt.slice(0, 10).replaceAll('-', '.') : el.createdAt.slice(0, 10).replaceAll('-', '.')
            el.text = el.workerComment
            el.main = el.korNm
          })
          this.userCommentList = res.list
          console.log('this.userCommentList', this.userCommentList)
          this.selectedGrp = this.selectedGrp.concat(this.userCommentList)
        }
      })
    },

    async clickTab(id) {
      if (this.selectedTab === id) return
      this.selectedTab = id
      this.btnSearch()
      // this.getUserComment()
    },
  },
}
</script>

<style lang="scss">
@keyframes guide-blink-red {
  0%,
  100% {
    color: inherit;
    box-shadow: inset 0 0 0 0 transparent;
    outline: 2px solid transparent;
    background-color: transparent;
  }
  50% {
    color: #f44336 !important;
    box-shadow: inset 0 0 0 2px rgba(244, 67, 54, 0.85);
    outline: 2px solid #f44336;
    background-color: rgba(244, 67, 54, 0.12);
  }
}

.guide-highlight-sample .btn_btnSample {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}

.guide-blink-target {
  animation: guide-blink-red 0.8s ease-in-out 5;
  border-radius: 8px;
}
</style>
